class StickyHeader extends HTMLElement {
  constructor() {
    super()

    this.selectors = {
      barCloseButton: '[data-header-bar-close]',
      navMobile: '[data-nav-mobile]',
      navMobileBack: '[data-nav-mobile-back]',
      navMobileButton: '[data-nav-button]',
      navMobileOverlay: '[data-nav-mobile-overlay]',
      headerBar: '[data-header-bar]',
      linkWithDropdown: '[data-link-has-dropdown]',
      adaDrawerToggler: '[data-ada-drawer-toggler]',
      navMobileDropdown: '[data-nav-mobile-dropdown]',
      mobileChatButton: '[data-mobile-chat-button]',
      navFirstLevelButton: '[data-nav-link-has-second-level]',
      navSecondLevelLink: '[data-nav-second-level-link]',
      navSecondLevelWrapper: '[data-nav-second-level-wrapper]',
      navOverlay: '[data-nav-overlay]',
      navThirdLevelMegamenu: '[data-nav-third-level-megamenu]',
      headerContainer: "[data-header-container]",
      navDrawer: '[data-nav-drawer]',
      navDrawerClose: '[data-nav-drawer-close]',
      navLevel2Link: '[data-nav-level2-link]',
    }
    this.classes = {
      headerNavOpen: 'is-nav-open',
      headerScrolled: 'is-scrolled',
      navMobileActive: 'is-visible',
      navMobileDropdownBehind: 'under',
      navMobileDropdownVisible: 'current',
      navMobileButtonActive: 'is-active',
      hidden: 'hidden',
      navLinkOpen: 'nav__link--opened',
      navDrawerOpened: 'nav__drawer--opened',
      navDrawerNoTransition: 'nav__drawer--no-transition',
    }
  }

  connectedCallback() {

    // Elements
    this.barCloseButton = this.querySelector(this.selectors.barCloseButton)
    this.headerBar = this.querySelector(this.selectors.headerBar)
    this.navMobile = this.querySelector(this.selectors.navMobile)
    this.navMobileButton = this.querySelector(this.selectors.navMobileButton)
    this.navMobileOverlay = this.querySelector(this.selectors.navMobileOverlay)
    this.navMobileDropdown = Array.from(this.querySelectorAll(this.selectors.navMobileDropdown))
    this.navOverlay = this.querySelector(this.selectors.navOverlay);
    this.adaDrawerTogglers = this.querySelectorAll(this.selectors.adaDrawerToggler);
    this.stickyHeader = document.querySelector('sticky-header');

    // Handlers
    this.onScrollHandler = this.onScroll.bind(this)
    this.onBarCloseHandler = this.barClose.bind(this)
    this.toggleMenuHandler = this.toggleMenu.bind(this)
    this.linkWithDropdownHandler = this.linkWithDropdownOnClick.bind(this)
    this.toggleChatHandler = this.toggleChat.bind(this)
    this.collapseMobileDropdownsHandler =
      this.collapseMobileDropdowns.bind(this)
    this.onEarlyAccessEnableHandler = this.onEarlyAccessEnable.bind(this);
    this.navDrawerCloseHandler = this.closeNavDrawer.bind(this);
    this.navFirstLevelHoverHandler = this.navFirstLevelHover.bind(this);
    this.navFirstLevelKeyDownHandler = this.navFirstLevelKeyDown.bind(this);
    this.onKeyDownHandler = this.onKeyDown.bind(this);
    this.navOverlayMouseEnterHandler = this.navOverlayMouseEnter.bind(this);

    // Ref
    this.pastDropdowns = this.navMobileDropdown.filter((dropdown) => dropdown.hasAttribute('data-base-layer'));

    window.addEventListener('scroll', this.onScrollHandler, false)
    window.addEventListener('load', this.onScrollHandler, false)
    window.addEventListener('enableEarlyAccess', this.onEarlyAccessEnableHandler, false)
    document.addEventListener('keydown', this.onKeyDownHandler, false)
    this.barCloseButton.addEventListener('click', this.onBarCloseHandler, false)
    this.navMobileButton.addEventListener('click', this.toggleMenuHandler, false)
    this.navMobileOverlay.addEventListener('click', (e) => {
      this.toggleMenuHandler(e, true)
    }, false)

    this.querySelectorAll(this.selectors.linkWithDropdown).forEach((link) => {
      link.addEventListener('click', this.linkWithDropdownHandler)
    })
    this.querySelectorAll(this.selectors.navMobileBack).forEach((button) => {
      button.addEventListener('click', this.collapseMobileDropdownsHandler)
    })
    this.querySelectorAll(this.selectors.mobileChatButton).forEach((button) => {
      button.addEventListener('click', this.toggleChatHandler);
    })

    this.headerBarClosed = window.sessionStorage.getItem('header-bar-closed')

    if (
      !this.headerBarClosed &&
      this.querySelector(this.selectors.headerBar).classList.contains(
        'has-content'
      )
    ) {
      this.headerBar.classList.remove(this.classes.hidden)
    }

    this.earlyAccessSession = window.sessionStorage.getItem('earlyAccess')
    if(this.earlyAccessSession) {
      this.onEarlyAccessEnable();
    }

    this.adaDrawerTogglers.forEach((button) => {
      button.addEventListener('click', this.navFirstLevelHoverHandler);
    })

    this.querySelectorAll(this.selectors.navFirstLevelButton).forEach((link) => {
      link.addEventListener('mouseenter', this.navFirstLevelHoverHandler);
    })

    // Drawer event listeners
    this.querySelectorAll(this.selectors.navDrawerClose).forEach((button) => {
      button.addEventListener('click', this.navDrawerCloseHandler)
    })

    // Add mouse enter handler for overlay to close drawer
    const overlay = this.querySelector(this.selectors.navOverlay);
    if (overlay) {
      overlay.addEventListener('mouseenter', this.navOverlayMouseEnterHandler);
    }

    window.addEventListener("resize", () => {
      this.updateDrawerHeight();
    }, {
      passive: true
    })
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler)
    window.removeEventListener('enableEarlyAccess', this.onEarlyAccessEnableHandler);
    document.removeEventListener('keydown', this.onKeyDownHandler, false);
  }

  toggleChat() {
    this.closeMenu();

    if (window.GorgiasChat) {
      window.GorgiasChat.open()
    }
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    this.classList.toggle(this.classes.headerScrolled, scrollTop > 0)
  }

  barClose() {
    this.headerBar.classList.add(this.classes.hidden)
    this.calcPageOffset()
    window.sessionStorage.setItem('header-bar-closed', true)
  }

  toggleMenu(e) {
    var headerHeight = this.closest('#shopify-section-header').offsetHeight
    this.navMobile.style.setProperty('--offset-top', `${headerHeight}px`);
    if(this.navMobile.classList.contains(this.classes.navMobileActive)) {
      this.closeMenu()
    } else {
      this.openMenu();
    }
  }

  openMenu() {
    this.navMobile.classList.add(this.classes.navMobileActive)
    this.navMobileButton.classList.add(this.classes.navMobileButtonActive)
    this.classList.add(this.classes.headerNavOpen)
    if(document.querySelector('#gorgias-chat-container')){
      document.querySelector('#gorgias-chat-container').style.display = "none";
    }

    if (typeof window.toggleBodyLock == 'function') {
      toggleBodyLock(this.navMobile, true);
    }
  }

  closeMenu() {
    this.navMobile.classList.remove(this.classes.navMobileActive)
    this.navMobileButton.classList.remove(this.classes.navMobileButtonActive)
    this.classList.remove(this.classes.headerNavOpen)

    this.navMobile.addEventListener('transitionend', () => {
      this.resetMobileNav();
    }, {once: true})

    if (typeof window.toggleBodyLock == 'function') {
      toggleBodyLock(this.navMobile, false);
    }

    if(document.querySelector('#gorgias-chat-container')){
      document.querySelector('#gorgias-chat-container').style.display = "block";
    }
  }

  resetMobileNav() {
    const firstLayerDropdown = this.navMobileDropdown.filter((dropdown) => dropdown.hasAttribute('data-base-layer'))
    this.pastDropdowns = firstLayerDropdown;

    this.navMobileDropdown.forEach((dropdown) => {
      dropdown.classList.remove(this.classes.navMobileDropdownVisible);
      dropdown.classList.remove(this.classes.navMobileDropdownBehind);
    })

    firstLayerDropdown[0].classList.add(this.classes.navMobileDropdownVisible);
    firstLayerDropdown[0].scrollTop = 0;
  }

  navFirstLevelButtonClick({e, link}) {
    if(e) {
      e.preventDefault();
    }

    this.closeAllMegamenus();
    this.closeAllSecondLevelNavs();
    this.deactivateFirstLevelLinks();
    this.closeNavDrawer();

    const secondLevelMenuRef = link.dataset.navLinkMenuRef;
    const isActive = link.classList.contains("nav__link--active");

    if (!isActive) {
      link.classList.add("nav__link--active");
      this.prepareNavDrawer(secondLevelMenuRef);
    }
  }

  linkWithDropdownOnClick(e) {
    e.preventDefault()

    const targetHandle = e.currentTarget.dataset.handle;

    const targetDropdown = this.navMobileDropdown.find((dropdown) => dropdown.dataset.handle === targetHandle);

    if (!targetDropdown) {
      return
    }

    this.pastDropdowns.forEach((drawer) => {
      drawer.classList.add(this.classes.navMobileDropdownBehind);
      drawer.classList.remove(this.classes.navMobileDropdownVisible);
    })

    targetDropdown.classList.add(this.classes.navMobileDropdownVisible);
    targetDropdown.scrollTop = 0;
    this.pastDropdowns.push(targetDropdown);
  }


  collapseMobileDropdowns(e) {
    const latestDropdown = this.pastDropdowns.pop();

    latestDropdown.classList.remove(this.classes.navMobileDropdownVisible);

    this.pastDropdowns.slice(-1)[0].classList.remove(this.classes.navMobileDropdownBehind);
    this.pastDropdowns.slice(-1)[0].classList.add(this.classes.navMobileDropdownVisible);
  }

  closeAllMegamenus() {
    const overlay = this.querySelector(this.selectors.navOverlay);

    overlay.classList.remove("active");

    document.querySelectorAll(this.selectors.navThirdLevelMegamenu).forEach((megamenu) => {
      megamenu.classList.remove("opened")
    })
    document.querySelectorAll(this.selectors.navSecondLevelWrapper).forEach((menu) => {
      menu.classList.remove("has-third-level-opened")
    })
    document.querySelectorAll(this.selectors.navSecondLevelLink).forEach((link) => {
      link.classList.remove("opened")
    })
  }

  closeAllSecondLevelNavs() {
    document.querySelectorAll(this.selectors.navSecondLevelWrapper).forEach((secondLevelMenu) => {
      secondLevelMenu.classList.remove("menu-level-2--opened")
    })
  }

  linkWithMegamenuOnMouseEnter(e) {
    const currentLink = e.target;
    const secondLevelWrapper = currentLink.closest(this.selectors.navSecondLevelWrapper);
    const megaMenuRef = currentLink.dataset.dropdownId;
    const thirdLevelMegamenu = currentLink.closest("[data-nav-second-level-wrapper]").querySelector(`[data-nav-third-level-megamenu="${megaMenuRef}"]`);
    const overlay = this.querySelector(this.selectors.navOverlay);
    const hasSomeThirdLevelMenuActive = this.querySelector(`${this.selectors.navThirdLevelMegamenu}.opened`);
    const hasSomeSecondLevelLinkActive = this.querySelector(`${this.selectors.navSecondLevelLink}.opened`);

    if (hasSomeThirdLevelMenuActive) {
      hasSomeThirdLevelMenuActive.classList.remove("opened");
      hasSomeSecondLevelLinkActive.classList.remove("opened");
    }

    if (!thirdLevelMegamenu) {
      secondLevelWrapper.classList.remove("has-third-level-opened");
      overlay.classList.remove("active");
      if (hasSomeSecondLevelLinkActive) {
        hasSomeSecondLevelLinkActive.classList.remove("opened");
      }
      return;
    }

    const isOpened = thirdLevelMegamenu.classList.contains("opened");
    if (!isOpened) {
      currentLink.classList.add("opened");
      thirdLevelMegamenu.classList.add("opened");
      overlay.classList.add("active");
      secondLevelWrapper.classList.add("has-third-level-opened");

      const gorgiasChatContainer = document.getElementById('gorgias-chat-container');
      if (gorgiasChatContainer) {
        gorgiasChatContainer.style.zIndex = 10;
      }
    }
  }

  linkWithMegamenuOnMouseLeave(e) {
    const currentElement = e.fromElement;
    const secondLevelLinkActive = this.querySelector(`${this.selectors.navSecondLevelLink}.opened`);
    const secondLevelWrapper = currentElement.closest(this.selectors.navSecondLevelWrapper);
    const overlay = this.querySelector(this.selectors.navOverlay);

    const gorgiasChatContainer = document.getElementById('gorgias-chat-container');
    if (gorgiasChatContainer) {
      gorgiasChatContainer.removeAttribute('style');
    }

    const isOpened = currentElement.classList.contains("opened");
    if (isOpened && e.toElement && !e.toElement.contains(currentElement)) {
      secondLevelLinkActive?.classList?.remove("opened");
      currentElement.classList.remove("opened");
      secondLevelWrapper.classList.remove("has-third-level-opened");
      overlay.classList.remove("active");
    }
  }

  calcPageOffset() {
    const main = document.querySelector('#MainContent')
    const headerHeight = this.calcHeaderHeight();

    main.style.paddingTop = `${headerHeight}px`

    this.calcAccountTop(headerHeight)
  }

  calcAccountTop(headerHeight) {
    const accountTabs = document.querySelectorAll('.js-account-tab')

    if (accountTabs && accountTabs[0]) {
      accountTabs.forEach((element) => {
        element.style.marginTop = `-${headerHeight}px`
        element.style.paddingTop = `${headerHeight}px`
      })
    }
  }

  onEarlyAccessEnable() {
    const earlyAccessButtons = this.querySelectorAll('.early-access');

    earlyAccessButtons.forEach(element => {
      element.classList.remove('hidden');
    })
  }

  openNavDrawer(drawerRef, eventType) {
    const drawer = this.querySelector(`[data-nav-drawer-ref="${drawerRef}"]`);
    const openDrawer = this.querySelector(`[data-nav-drawer].${this.classes.navDrawerOpened}`);
    this.updateDrawerHeight(drawer);

    if (drawer) {
      if(openDrawer) {
        openDrawer.classList.add(this.classes.navDrawerNoTransition);
        drawer.classList.add(this.classes.navDrawerNoTransition);
        openDrawer.classList.remove(this.classes.navDrawerOpened);
      }

      const headerHeight = this.closest('#shopify-section-header').offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      drawer.classList.add(this.classes.navDrawerOpened);

      this.navOverlay.classList.add("active");
      if(eventType == 'click') {
        if(!openDrawer) {
          drawer.addEventListener('transitionend', () => {
            trapFocus(drawer)
          }, {once: true})
        } else {
          trapFocus(drawer);
        }
      }
    }
  }

  closeNavDrawer(shouldMovefocus = true) {
    const openDrawer = this.querySelector(`.${this.classes.navDrawerOpened}`);
    const togglerButton = this.querySelector(`[data-ada-drawer-toggler="${openDrawer.dataset.navDrawerRef}"]`)
    togglerButton.setAttribute('aria-expanded', false);

    if (openDrawer) {
      openDrawer.classList.remove(this.classes.navDrawerNoTransition)
      openDrawer.classList.remove(this.classes.navDrawerOpened);
      this.navOverlay.classList.remove('active');

      openDrawer.addEventListener('transitionend', () => {
        console.log(shouldMovefocus);
        if(shouldMovefocus) {
          removeTrapFocus(togglerButton);
        }
        this.deactivateFirstLevelLinks();
      }, {once: true})
    }
  }

  prepareNavDrawer(drawerRef) {
    const drawer = this.querySelector(`[data-nav-drawer-ref="${drawerRef}"]`);
    if (drawer) {
      const headerHeight = this.closest('#shopify-section-header').offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }
  }

  navOverlayMouseEnter(e) {
    this.closeNavDrawer(false);
  }

  navFirstLevelHover(e) {
    const target = e.currentTarget;
    const secondLevelMenuRef = target.dataset.navLinkMenuRef;

    this.deactivateFirstLevelLinks();
    this.openNavDrawer(secondLevelMenuRef, e.type);
    target.setAttribute('aria-expanded', "true");

    target.parentElement.classList.add(this.classes.navLinkOpen);

    this.querySelector('.header__nav').classList.add('header__nav--drawer-open');
  }

  deactivateFirstLevelLinks() {
    this.querySelector('.header__nav').classList.remove('header__nav--drawer-open');
    document.querySelectorAll(this.selectors.navFirstLevelButton).forEach((firstLevelLink) => {
      firstLevelLink.parentElement.classList.remove(this.classes.navLinkOpen)
    })
  }

  navFirstLevelKeyDown(e) {
    // Check if Enter key is pressed
    if (e.key === 'Enter' || e.keyCode === 13) {
      // Get the element with data-nav-link-has-second-level (might be currentTarget or its parent)
      let navElement = e.currentTarget;

      // If the event is on a child element (like <a>), find the parent with data-nav-link-has-second-level
      if (!navElement.hasAttribute('data-nav-link-has-second-level')) {
        navElement = navElement.closest(this.selectors.navFirstLevelButton);
      }

      if (navElement && navElement.hasAttribute('data-nav-link-has-second-level')) {
        e.preventDefault();
        e.stopPropagation();
        const secondLevelMenuRef = navElement.dataset.navLinkMenuRef;

        // Close other navigation elements
        this.closeAllMegamenus();
        this.deactivateFirstLevelLinks();

        // Toggle the drawer: if already active, close it; otherwise open it
        const isActive = navElement.classList.contains("nav__link--active");

        if (isActive) {
          navElement.classList.remove("nav__link--active");
          this.closeNavDrawer();
          const overlay = this.querySelector(this.selectors.navOverlay);
          if (overlay) {
            overlay.classList.remove("active");
          }
        } else {
          navElement.classList.add("nav__link--active");
          this.openNavDrawer(secondLevelMenuRef, true);
          const overlay = this.querySelector(this.selectors.navOverlay);
          if (overlay) {
            overlay.classList.add("active");
          }
        }
      }
    }
  }

  updateDrawerHeight(drawer) {
    const maxHeight = window.innerHeight - this.stickyHeader.offsetHeight;
    if(drawer) {
      drawer.style.maxHeight = maxHeight + 'px';
    } else {
      const drawers = Array.from(this.querySelectorAll(this.selectors.navDrawer));

      drawers.forEach(drawer => {
        drawer.style.maxHeight = maxHeight + 'px';
      })

    }
  }

  onKeyDown(e) {
    // Close navigation elements when Escape key is pressed
    if (e.key === 'Escape' || e.keyCode === 27) {
      // Close drawer if open
      const openDrawer = this.querySelector(`.${this.classes.navDrawerOpened}`);
      if (openDrawer) {
        this.closeNavDrawer();
        // Also deactivate first level links and remove overlay
        this.deactivateFirstLevelLinks();
        const overlay = this.querySelector(this.selectors.navOverlay);
        if (overlay) {
          overlay.classList.remove("active");
        }
        e.preventDefault();
        return;
      }

      // Close mobile menu if open
      if (this.navMobile && this.navMobile.classList.contains(this.classes.navMobileActive)) {
        this.closeMenu();
        e.preventDefault();
        return;
      }

      // Close megamenus if open
      const hasOpenedMegamenu = this.querySelector(`${this.selectors.navThirdLevelMegamenu}.opened`);
      if (hasOpenedMegamenu) {
        this.closeAllMegamenus();
        e.preventDefault();
        return;
      }
    }
  }
}

customElements.define('sticky-header', StickyHeader)

